module.exports = __webpack_public_path__ + "img/doc-icon.5f75b275.svg";